function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';
import styled from '../../_snowpack/pkg/styled-components.js';
const defaultSize = '20px';

const setWidth = ({
  size,
  width
}) => width || size || defaultSize;

const setHeight = ({
  size,
  height
}) => height || size || defaultSize;

const SVG = styled.svg.withConfig({
  displayName: "trashcan-bucket__SVG",
  componentId: "eo95zj-0"
})(["width:", ";height:", ";.icon-trashcan-fill{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke:", ";}"], setWidth, setHeight, p => p.color || 'currentColor');
export default (({
  fill,
  ...rest
}) => /*#__PURE__*/React.createElement(SVG, _extends({
  viewBox: "0 0 40 40"
}, rest, {
  fill: fill
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "icon-trashcan-fill",
  style: {
    strokeWidth: '1.2'
  },
  d: "M29.1,12.6l-2.4,16.6c-0.1,1-1,1.7-2,1.7h-9.5c-1,0-1.8-0.7-2-1.7l-2.4-16.6"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "icon-trashcan-fill",
  style: {
    strokeWidth: '0.4'
  },
  x1: "24.5",
  y1: "16.6",
  x2: "23",
  y2: "26.8"
}), /*#__PURE__*/React.createElement("line", {
  className: "icon-trashcan-fill",
  style: {
    strokeWidth: '0.4'
  },
  x1: "20",
  y1: "26.8",
  x2: "20",
  y2: "16.6"
}), /*#__PURE__*/React.createElement("line", {
  className: "icon-trashcan-fill",
  style: {
    strokeWidth: '0.4'
  },
  x1: "17",
  y1: "26.8",
  x2: "15.5",
  y2: "16.6"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "icon-trashcan-fill",
  style: {
    strokeWidth: '1.2'
  },
  x1: "10.9",
  y1: "12.5",
  x2: "26.5",
  y2: "12.5"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "icon-trashcan-fill",
  style: {
    strokeWidth: '1.2'
  },
  x1: "31.8",
  y1: "12.5",
  x2: "8.2",
  y2: "12.5"
})))));